import { Badge, Tooltip } from '@mantine/core';
import * as Mui from '@material-ui/core';
import { memo, useMemo } from 'react';
import { useTheme } from '../../../../ThemeContext';
import { IconBuilding, IconCheck, IconReport, IconUser } from '../../../../components/svg';
import { useTranslation } from 'react-i18next';


const OrgInfo = ({ label, value }) => {

    return <Mui.Typography
        component="h5"
        variant="h5"
        className="d-flex mb-2 mr-5 svg-color-primary font-weight-normal"
    >
        <span className="ml-2 word-break-word">
            <Mui.Typography
                component="small"
                variant="body2"
                className="d-block text-color-grey text-transform-uppercase font-weight-medium"
            >
                {label}
            </Mui.Typography>
            {value}
        </span>
    </Mui.Typography>
}

export const OnboardReview = ({ formikProps }) => {
    const { t } = useTranslation();
    const { theme } = useTheme();

    const borderColor = theme === 'dark' ? '#37395B' : '#E9ECEF'
    const strokeColor = theme === 'dark' ? '#9aa1a7' : '#414651'

    return <Mui.Box
        className='d-flex align-items-center'
        flexDirection={'column'}
        style={{
            border: `1px solid ${borderColor}`,
            padding: '2rem',
            borderRadius: '1rem'
        }}>
        <Mui.Box className='d-flex mt-3 mb-3' flexDirection={'column'}>
            <Mui.Box style={{ border: `1.5px solid ${borderColor}`, padding: '2rem', borderRadius: '1rem' }} className='d-flex justify-content-center align-items-center align-self-center'>
                <IconCheck height={30} width={30} stroke={strokeColor} />
            </Mui.Box>
            <Mui.Typography className='font-weight-medium mt-2 mb-1' variant='h4' component='h4' style={{ textAlign: 'center' }}>{t("ORGANIZATION.ONBOARD.REVIEW.READY")}</Mui.Typography>
            <Mui.Typography
                variant='body1'
                // component='h5'
                style={{
                    textAlign: 'center',
                    color: '#9aa1a7'
                }}
            >
                {t("ORGANIZATION.ONBOARD.REVIEW.DESC")}
            </Mui.Typography>
        </Mui.Box>
        <Mui.Box style={{ border: `2px solid ${borderColor}`, borderRadius: '1rem', width: '100%' }}>
            <Mui.Box style={{ padding: '2.5rem', borderBottom: `1px solid ${borderColor}` }}>
                <Mui.Box className='d-flex align-items-center mb-2' gridGap={10}>
                    <IconBuilding height={25} width={25} stroke={strokeColor} />
                    <Mui.Typography variant='h5' component='h5' className='text-transform-uppercase font-weight-medium'>{t("ORGANIZATION.ONBOARD.REVIEW.ORG_DETAILS")}</Mui.Typography>
                </Mui.Box>
                <Mui.Grid container spacing={2}>
                    <Mui.Grid item xs={12} sm={6} md={5} className='mb-2'>
                        <OrgInfo label={t("ORGANIZATION.ONBOARD.REVIEW.ORG_NAME")} value={formikProps.values.name} />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} sm={6} md={5} className='mb-2'>
                        <OrgInfo label={t("ORGANIZATION.ONBOARD.REVIEW.ORG_NUMBER")} value={formikProps.values.number} />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} className='mb-2'>
                        <OrgInfo label={t("ORGANIZATION.ONBOARD.REVIEW.TENANT_URL")} value={formikProps.values.websiteId || '-'} />
                    </Mui.Grid>
                    <Mui.Grid item xs={12} >
                        <OrgInfo label={t("ORGANIZATION.ONBOARD.REVIEW.HQ_ADDRESS")} value={`${formikProps.values.streetName} ${formikProps.values.streetNumber}, ${formikProps.values.postalCode} ${formikProps.values.city}, ${formikProps.values.region}`} />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.Box>
            <Mui.Box style={{ padding: '2.5rem', borderBottom: `1px solid ${borderColor}`, backgroundColor: theme === 'dark' ? '#37395B50' : '#F8FAFC50' }}>
                <Mui.Box className='d-flex align-items-center mb-2' gridGap={10}>
                    <IconUser height={25} width={25} stroke={strokeColor} />
                    <Mui.Typography variant='h5' component='h5' className='text-transform-uppercase font-weight-medium'>{t("ORGANIZATION.ONBOARD.REVIEW.ADMINS_TITLE")}</Mui.Typography>
                </Mui.Box>
                <Mui.Box className='d-flex' flexDirection={'column'} gridGap={10}>
                    {formikProps.values.adminUser.map((admin, index) => (
                        <Mui.Box
                            key={index}
                            className='d-flex justify-content-between'
                            gridGap={10}
                            style={{
                                padding: '2rem 0',
                                border: `1.5px solid ${borderColor}`,
                                borderRadius: '1rem',
                                backgroundColor: theme === 'dark' ? 'transparent' : '#ffffff'
                            }}
                        >
                            <Mui.Typography
                                component="h5"
                                variant="h5"
                                className="d-flex mr-5 svg-color-primary font-weight-medium"
                            >
                                <span className="ml-2 word-break-word">
                                    <Mui.Typography
                                        component="small"
                                        variant="body2"
                                        className="d-block text-color-grey text-transform-uppercase"
                                    >
                                        {t("ORGANIZATION.ONBOARD.REVIEW.NAME")}
                                    </Mui.Typography>
                                    {admin.name}
                                </span>
                            </Mui.Typography>
                            <Mui.Typography
                                component="h5"
                                variant="h5"
                                className="d-flex mr-5 svg-color-primary font-weight-normal"
                                style={{ textAlign: 'right' }}
                            >
                                <span className="ml-2 word-break-word">
                                    <Mui.Typography
                                        component="small"
                                        variant="body2"
                                        className="d-block text-color-grey text-transform-uppercase"
                                    >
                                        {t("ORGANIZATION.ONBOARD.REVIEW.EMAIL")}
                                    </Mui.Typography>
                                    {admin.email}
                                </span>
                            </Mui.Typography>
                        </Mui.Box>
                    ))}
                </Mui.Box>
            </Mui.Box>
            <Mui.Box style={{ padding: '2.5rem', backgroundColor: theme === 'dark' ? '#37395B' : '#F8FAFC' }}>
                <Mui.Box className='d-flex align-items-center justify-content-between mb-3'>
                    <Mui.Box className='d-flex align-items-center' gridGap={10}>
                        <IconReport height={25} width={25} stroke={strokeColor} />
                        <Mui.Typography variant='h5' component='h5' className='text-transform-uppercase font-weight-medium'>{t("ORGANIZATION.ONBOARD.REVIEW.PRODUCT_SYNC")}</Mui.Typography>
                    </Mui.Box>
                </Mui.Box>
                <ProductSyncInfo formikProps={formikProps} />
            </Mui.Box>
        </Mui.Box>
    </Mui.Box>
}


const ProductSyncInfo = memo(({ formikProps }) => {
    const { t } = useTranslation();

    const totalProducts = formikProps.values.categories.reduce((acc, category) => acc + category.subCategories.reduce((acc, subCategory) => acc + subCategory.products.length, 0), 0);

    let categoryProgress = useMemo(() =>
        formikProps.values.categories.map((category) => {
            const totalProductsInCategory = category.subCategories.reduce((acc, subCategory) => acc + subCategory.products.length, 0);
            return {
                value: (totalProductsInCategory / totalProducts) * 100,
                color: category.color?.bg ?? '#60A5FA',
                label: `${category.parentCategory?.name}`,
                totalProducts: totalProductsInCategory
            }
        }), [formikProps.values.categories, totalProducts])

    if (totalProducts === 0) categoryProgress = [
        {
            value: 100,
            color: '#FB923C',
            label: t("ORGANIZATION.ONBOARD.REVIEW.NO_PRODUCTS"),
            totalProducts: 0
        }
    ];

    return <Mui.Box display='flex' style={{ width: '100%', height: '30px', padding: '0.5rem', borderRadius: '1rem' }}>
        {categoryProgress.map((item, index) => (
            <Tooltip
                key={index}
                label={
                    <Badge
                        size="lg"
                        variant="filled"
                        style={{ backgroundColor: '#DBEAFE', color: '#1D4ED8' }}
                    >
                        {item.label} ({item.totalProducts} {t("ORGANIZATION.ONBOARD.REVIEW.PRODUCTS_SELECTED", { count: item.totalProducts })})
                    </Badge>
                }
                style={{ width: `${item.value}%`, }}
                styles={{
                    body: { backgroundColor: 'transparent' }
                }}
            >
                <Mui.Box
                    key={index}
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        height: '100%',
                        backgroundColor: item.color ?? '#60A5FA',
                        borderRadius: item.value === 100 ? '1rem' : index === 0 ? '1rem 0 0 1rem' : index === categoryProgress.length - 1 ? '0 1rem 1rem 0' : '0'
                    }}>
                    <Mui.Typography variant='body1' component='span' style={{ color: 'white' }}>
                        {item.value < 13 ? `${item.label.substring(0, 5)}...` : `${item.label} (${item.totalProducts})`}
                    </Mui.Typography>
                </Mui.Box>
            </Tooltip>
        ))}
    </Mui.Box>
    // return <Progress
    //     size={20}
    //     radius="md"
    //     sections={categoryProgress}
    // />
})